import {
  USER_ACTIVITY,
  IUserActivityStartRequest,
  IUserActivityStopRequest,
} from "./types";

export function userActivityStart(): IUserActivityStartRequest {
  return {
    type: USER_ACTIVITY.START,
  };
}

export function userActivityStop(): IUserActivityStopRequest {
  return {
    type: USER_ACTIVITY.STOP,
  };
}
